module.exports = __webpack_public_path__ + "img/luck-boy.5c028feb.png";